import React, { createContext, useState, useContext } from "react";

const CTAL_Context = createContext();
export const useCTAL = () => useContext(CTAL_Context);

const CTAL_Provider = (props) => {   
    const [user_id, setUserID] = useState(); 
    const [team_id, setTeamID] = useState(""); 
    
    const [team, setTeam] = useState();
    const [team_ready, setTeamReady] = useState(false);
    const [app_user, setAppUser] = useState();
    const [action_item, setActionItem] = useState();
    const [short_term_goal, setShortTermGoal] = useState();

    const [num_display_columns, setNumDisplayColumns] = useState(3);
    const [main_column_display_type,  setMainColumnDisplayType] = useState("Team"); //User, Team, Action-Item
    const [action_item_list_display, setActionItemListDisplay] = useState();

    const [user_short_list, setUserShortList] = useState();
    const [user_long_list, setUserLongList] = useState();
    const [user_public_team_list, setUserPublicTeamList] = useState([]);
    const [user_team_invitations_list, setUserTeamInvitationsList] = useState([]);
    const [user_join_requests_list, setUserJoinRequestsList] = useState([]);

    const [team_member_role, setTeamMemberRole] = useState("");
    const [team_members_list, setTeamMembersList] = useState([]);
    const [team_invitations_list, setTeamInvitationsList] = useState([]);
    const [team_outside_invitations_list, setTeamOutsideInvitationsList] = useState([]);
    const [team_join_requests_list, setTeamJoinRequestsList] = useState([]);
    const [team_tags, setTeamTags] = useState([]);
    const [team_short_term_goals, setTeamShortTermGoals] = useState([]);
    const [team_history_events, setTeamHistoryEvents] = useState([]);
    const [team_transactions, setTeamTransactions] = useState([]);

    const [action_item_files, setActionItemFiles] = useState([]);
    const [action_item_comments, setActionItemComments] = useState([]);
    const [action_item_comment_files, setActionItemCommentFiles] = useState([]);
    const [action_item_history_events, setActionItemHistoryEvents] = useState([]);
    const [action_item_tag_assignments, setActionItemTagAssignments] = useState([]);
    const [action_item_reactions, setActionItemReactions] = useState([]);
    const [action_item_comment_reactions, setActionItemCommentReactions] = useState([]);

    const [app_admin_users_list, setAppAdminUsersList] = useState([]);
    const [app_admin_public_teams_list, setAppAdminPublicTeamsList] = useState([]);
    
    const [user_display_refresh, setUserDisplayRefresh] = useState(false);
    const [team_display_refresh, setTeamDisplayRefresh] = useState(false);
    const [team_card_display_refresh, setTeamCardDisplayRefresh] = useState(false);
    const [action_item_display_refresh, setActionItemDisplayRefresh] = useState(false);
    const [app_admin_users_refresh, setAppAdminUsersRefresh] = useState(false);
    const [app_admin_public_teams_refresh, setAppAdminPublicTeamsRefresh] = useState(false);
    
    const [user_changed_action_item, setUserChangedActionItem] = useState(false); //Flag to indicate User Changed an Action-Item
    const [action_item_list_local_refresh, setActionItemListLocalRefresh] = useState(false); //Local AI List Refresh without DB Fetch
    
    const [action_item_short_list_refresh, setActionItemShortListRefresh] = useState(false);
    const [action_item_long_list_refresh, setActionItemLongListRefresh] = useState(false);
    const [action_item_team_list_refresh, setActionItemTeamListRefresh] = useState(false);
    
    const [action_item_short_list_count_refresh, setActionItemShortListCountRefresh] = useState(false);
    const [action_item_long_list_count_refresh, setActionItemLongListCountRefresh] = useState(false);

    const [new_action_item_flag, setNewActionItemFlag] = useState(false);
    const [selected_action_item, setSelectedActionItem] = useState();
    
    return ( 
        <CTAL_Context.Provider 
            value={{ user_id, setUserID, 
                     app_user, setAppUser, 
                     team_id, setTeamID, 
                     team, setTeam, 
                     team_ready, setTeamReady,
                     action_item, setActionItem,
                     short_term_goal, setShortTermGoal, 
                     num_display_columns, setNumDisplayColumns,
                     main_column_display_type,  setMainColumnDisplayType,
                     action_item_list_display, setActionItemListDisplay,
                     user_short_list, setUserShortList, 
                     user_long_list, setUserLongList,
                     user_public_team_list, setUserPublicTeamList,
                     user_team_invitations_list, setUserTeamInvitationsList,
                     user_join_requests_list, setUserJoinRequestsList,
                     team_member_role, setTeamMemberRole,
                     team_members_list, setTeamMembersList,
                     team_invitations_list, setTeamInvitationsList,
                     team_outside_invitations_list, setTeamOutsideInvitationsList,
                     team_join_requests_list, setTeamJoinRequestsList,
                     team_tags, setTeamTags,
                     team_short_term_goals, setTeamShortTermGoals,
                     team_history_events, setTeamHistoryEvents,
                     team_transactions, setTeamTransactions,                 
                     action_item_files, setActionItemFiles,
                     action_item_comments, setActionItemComments,
                     action_item_comment_files, setActionItemCommentFiles,
                     action_item_history_events, setActionItemHistoryEvents,
                     action_item_tag_assignments, setActionItemTagAssignments,
                     action_item_reactions, setActionItemReactions,
                     action_item_comment_reactions, setActionItemCommentReactions,
                     app_admin_users_list, setAppAdminUsersList, 
                     app_admin_public_teams_list, setAppAdminPublicTeamsList,                
                     user_display_refresh, setUserDisplayRefresh,
                     team_display_refresh, setTeamDisplayRefresh,
                     team_card_display_refresh, setTeamCardDisplayRefresh,
                     action_item_display_refresh, setActionItemDisplayRefresh,
                     app_admin_users_refresh, setAppAdminUsersRefresh,
                     app_admin_public_teams_refresh, setAppAdminPublicTeamsRefresh,
                     user_changed_action_item, setUserChangedActionItem,
                     action_item_list_local_refresh, setActionItemListLocalRefresh,
                     action_item_short_list_refresh, setActionItemShortListRefresh,
                     action_item_long_list_refresh, setActionItemLongListRefresh,
                     action_item_team_list_refresh, setActionItemTeamListRefresh,
                     action_item_short_list_count_refresh, setActionItemShortListCountRefresh,
                     action_item_long_list_count_refresh,  setActionItemLongListCountRefresh,
                     new_action_item_flag, setNewActionItemFlag, 
                     selected_action_item, setSelectedActionItem }} > 
            {props.children} 
        </CTAL_Context.Provider> 
    );
};

export default CTAL_Provider;
